"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
var React = require("react");
var SearchIcon_style_1 = require("./SearchIcon.style");
var Loader_1 = require("../Loader");
var searchIcon = function (color) { return (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 100 100" },
    React.createElement("path", { fill: color, fillRule: "evenodd", d: "M65.25 57l34.58 34.57-8.49 8.49-34.61-34.62a36 36 0 1 1 8.52-8.45zM36 62a26 26 0 1 0 0-52 26 26 0 0 0 0 52z" }))); };
exports.SearchIcon = function (props) {
    var loading = props.loading, _a = props.size, size = _a === void 0 ? 2 : _a, _b = props.color, color = _b === void 0 ? '#fff' : _b;
    return (React.createElement(SearchIcon_style_1.default.Icon, { size: size }, loading ? React.createElement(Loader_1.default, { type: "circle", color: color, size: size, inline: true }) : searchIcon(color)));
};
exports.default = exports.SearchIcon;
//# sourceMappingURL=SearchIcon.js.map